<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        rowKey="cosId"
        :row-selection="{ onChange: onSelectRowsChange }"
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        @mask="showMask"
        ref="tableRef"
        tableId="DcCosFbuPublicCustomer"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="客户阶段">
              <a-select
                v-model:value="queryForm.stage"
                :options="stageEnum"
                placeholder="请选择"
                allowClear
              />
            </dc-form-item>
            <dc-form-item label="客户名称">
              <a-input v-model:value.trim="queryForm.customerName" :maxlength="100" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="来源渠道">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="queryForm.channelList"
                  appId="cos_fbu"
                  paramCode="fbu_source_channel"
                  style="width: 33%"
                />
                <a-input
                  v-model:value="queryForm.channelExplain"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                  allowClear
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="创建时间">
              <CosRangePicker v-model:startTime="queryForm.createTimeStart" v-model:endTime="queryForm.createTimeEnd" />
            </dc-form-item>
            <dc-form-item label="子客户代码">
              <a-input v-model:value="queryForm.arkCode" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="联系方式">
              <a-input-group compact>
                <a-select v-model:value="queryForm.contact.type" style="width: 33%" placeholder="请选择">
                  <a-select-option :value="1">手机号</a-select-option>
                  <a-select-option :value="2">固定电话</a-select-option>
                  <a-select-option :value="3">邮箱</a-select-option>
                  <a-select-option :value="4">微信号</a-select-option>
                  <a-select-option :value="5">qq</a-select-option>
                </a-select>
                <a-input
                  v-model:value="queryForm.contact.keyword"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="客户区域">
              <CustomerAreaCascader type="search" appId="cos_fbu" v-model:ids="queryForm.customerRegionList" />
            </dc-form-item>
            <dc-form-item label="前负责人">
              <UserSelect v-model:value="queryForm.prevSeller" placeholder="请选择" allowClear />
            </dc-form-item>
            <dc-form-item label="客户ID">
              <a-input v-model:value="queryForm.cosId" :maxlength="500" allowClear placeholder="请输入" />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="'fbu_public_customer_assign_btn'" type="primary" @click="handleAssignPerson()"
            >分配客户</a-button
          >
          <a-button v-permission="'fbu_public_customer_receive_btn'" @click="handleReceive()">领取客户</a-button>
          <a-button v-permission="'fbu_public_customer_assign_region_btn'" @click="handleAllotRegion()"
            >分配区域</a-button
          >
          <ExportButton v-permission="'fbu_public_customer_export_btn'" appId="cos_fbu" taskType="226" :search="queryForm"
            >导出</ExportButton
          >
        </template>

        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'customerName'">
            <div class="flex">
              <p class="time-out-flag" v-if="record.timeoutFlag === true">超时</p>
              <p class="new-list-flag" v-if="record.haveFollowFlag === false">New</p>
              <p class="black-list-flag" v-if="record.blackListFlag">黑名单</p>
              <router-link
                :to="detailUrl(record)"
                class="ant-table-cell-ellipsis"
                :title="text"
                >{{ text || '--' }}</router-link
              >
            </div>
          </template>
          <template v-if="column.dataIndex === 'arkCode'">
            <p>{{ Array.isArray(text) && text.length > 0 ? text.join('、') : '--' }}</p>
          </template>
          <template v-if="column.dataIndex === 'channel'">
            <ChannelText appId="cos_fbu" paramCode="fbu_source_channel" :value="text" :desc="record.channelExplain" />
          </template>
          <template v-if="column.dataIndex === 'turnedTransaction'">
            <p>{{ record.turnedTransaction ? `成交客户(${record.turnedTransaction})` : (record.turnedContract ? `签约客户(${record.turnedContract})` : (record.turnedPotential ? `潜在客户(${record.turnedPotential})` : '--')) }}</p>
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_fbu" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a-button v-permission="'fbu_public_customer_assign_btn'" type="link" @click="handleAssignPerson(record)"
              >分配客户</a-button
            >
            <a-button v-permission="'fbu_public_customer_receive_btn'" type="link" @click="handleReceive(record)"
              >领取客户</a-button
            >
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>

  <!-- 分配客户负责人弹窗 -->
  <CustomerAssign ref="customerAssignRef" @fetch="handleQueryChange('fetch')" />
  <CustomerAllotRegion ref="customerAllotRegionRef" @fetch="handleQueryChange('fetch')" />
</template>

<script setup lang="ts">
import { reactive, computed, ref, onMounted, toRaw } from 'vue'
import { useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import { genderEnum, linkRoleTypeEnum, customerAllStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import CustomerAssign from '../components/customerAssign.vue'
import CustomerAllotRegion from '../components/customerAllotRegion.vue'
import { customerStageEnum } from '@/views/marketing/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { publicCustomerList, potentialDetail, publicCustomerCollect } from '@/api/gucangSales/customerCenter'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuPublicClueParams, FbuPublicClueListItem } from '@/typings/api/clueManage'
const route = useRoute()

// 线索类型枚举列表
const stageEnum = computed(() => customerStageEnum.filter((item) => item.value !== 1))
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  fbu_follow_purpose: [], // 拜访目的
  fbu_follow_mode: [] // 拜访方式（跟进方式）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_follow_purpose', 'fbu_follow_mode']
  }).then((res) => {
    Object.assign(paramCodeData, res.data)
  })
}

onMounted(() => {
  getByParamCodes()
})

// 获取详情联系人信息
const showMask = (record: FbuPublicClueListItem, callBack: (res: any) => void) => {
  potentialDetail(record.cosId).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}

const tableRef = ref()
const queryForm = reactive<FbuPublicClueParams>({ contact: { type: 1 } })

const detailUrl = (record: FbuPublicClueListItem) => {
  if (record.stage === 2) {
    return `/fbu/potential/view?cosId=${record.cosId}&isPublicClue=1`
  } else if (record.stage === 3) {
    return `/fbu/contract/view?cosId=${record.cosId}&isPublicClue=1`
  } else if (record.stage === 4) {
    return `/fbu/clients/view?cosId=${record.cosId}&isPublicClue=1`
  }
}

const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  { title: '客户ID', dataIndex: 'cosId', width: 200 },
  { title: '主客户代码', dataIndex: 'customerNumber' },
  { title: '来源渠道', dataIndex: 'channel' },
  { title: '客户阶段', dataIndex: 'stage', dicData: customerStageEnum },
  { title: '客户状态', dataIndex: 'status', dicData: customerAllStatusEnum },
  { title: '历史最高客户阶段', dataIndex: 'turnedTransaction', width: 260 },
  { title: '客户区域', dataIndex: 'customerRegion' },
  { title: '前负责人', dataIndex: 'prevSellerName' },
  { title: '最新跟进情况', dataIndex: 'followDesc' },
  { title: '子客户代码', dataIndex: 'arkCode' },
  { title: '联系人姓名', dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: '手机号', dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: '微信号', dataIndex: ['contact', 'wechat'], cosType: 'mask' },
  { title: '邮箱', dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: 'QQ号', dataIndex: ['contact', 'qq'], cosType: 'mask' },
  { title: '固定电话', dataIndex: ['contact', 'tel'], cosType: 'mask' },
  { title: '性别', dataIndex: ['contact', 'sex'], dicData: genderEnum },
  { title: '角色', dataIndex: ['contact', 'jobRole'], dicData: linkRoleTypeEnum },
  { title: '创建时间', dataIndex: 'createTime', width: 190 },
  { title: '上次领取时间', dataIndex: 'lastReceiveTime', width: 190 },
  { title: '流转公海池时间', dataIndex: 'transferTime', width: 190 },
  { title: '备注', dataIndex: 'remark' },
  { title: '操作', dataIndex: 'action', width: 200, fixed: 'right' }
])
const getList = (queryForm: FbuPublicClueParams, callBack: (res: any) => void) => {
  publicCustomerList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

const selectedData = ref<FbuPublicClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: FbuPublicClueListItem[]) => {
  selectedData.value = selectedRows
}

// 分配客户负责人
const customerAssignRef = ref()
const handleAssignPerson = (row?: FbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning('请选择需要分配的客户')
  const data = row ? [row] : toRaw(selectedData.value)
  customerAssignRef.value?.init(data)
}

// 分配客户区域
const customerAllotRegionRef = ref()
const handleAllotRegion = (row?: FbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning('请选择需要分配的客户')
  const data = row ? [row] : toRaw(selectedData.value)
  customerAllotRegionRef.value?.init(data)
}
// 领取客户
const handleReceive = (row?: FbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.warning('请选择需要领取的客户')
  }
  const cosIdList: any[] = []
  if (row) {
    cosIdList.push(row.cosId)
  } else {
    selectedData.value.forEach((item) => {
      cosIdList.push(item.cosId)
    })
  }
  AModal.confirm({
    title: '是否确认领取？',
    okText: '领取',
    onOk() {
      publicCustomerCollect({ cosIdList }).then(() => {
        message.success('领取成功')
        handleQueryChange('fetch')
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCancel() {}
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuPublicCustomer' }
</script>

  <style scoped></style>
